<template>
  <b-row align-h="center">
    <b-modal id="cbModal" size="md" ref="cbModal" @ok="onClickCbModalOk" ok-variant="primary" cancel-variant="danger" :title="$t('osm.contents.general.changeBusiness.title') + ' - ' + $t('osm.contents.general.changeBusiness.transferIn')">
      <h4>{{$t('osm.contents.general.changeBusiness.transferInConfirm')}}
      </h4>
    </b-modal>
    <div class="w-75">
      <b-alert :show="alertCd" dismissible variant="danger" @dismissed="alertCd=0">{{$t('general.updateError')}}</b-alert>
      <div class="text-right">
        <FITButton @click="submitTransferIn" variant="primary" :text="$t('osm.contents.general.changeBusiness.transferIn')" size="md"></FITButton>
      </div>
      <FITFormCard>
        <b-row slot="header" align-v="center">
          <b-col cols="6">
            <h5><i class="fa fa-info-circle mr-2"></i>{{$t('osm.contents.lifePolicy.generalInfo')}}</h5></b-col>
        </b-row>
        <div slot="formBody">
          <h3><b><i class="fa fa-align-justify mr-2"></i>{{$t('osm.contents.lifePolicy.general')}}</b></h3>
          <b-row class="mb-0 pb-0">
            <b-col cols="6">
              <FITAutoSearch :label="$t('osm.contents.lifePolicy.generalInformation.productName')" :width="8" v-model="selectedProduct" dest=option v-bind="productAutoSearchParams"></FITAutoSearch>
              <FITTextInput :label="$t('osm.contents.lifePolicy.generalInformation.policyNumber')" :width="8" type="text" v-model="lifeGeneralInfo.policyNumber"></FITTextInput>
              <FITTextInput :label="$t('osm.contents.lifePolicy.generalInformation.policyReference')" :width="8" type="text" v-model="lifeGeneralInfo.policyReference"></FITTextInput>
              <FITDatePicker :label="$t('osm.contents.lifePolicy.generalInformation.applicationDate')" :width="8" v-model="lifeGeneralInfo.applicationDate" :placeholder="$t('general.selectDate')"></FITDatePicker>
              <FITDatePicker :label="$t('osm.contents.lifePolicy.generalInformation.applicationReceivedDate')" :width="8" v-model="lifeGeneralInfo.applicationReceivedDate"></FITDatePicker>
              <FITTextInput :label="$t('osm.contents.lifePolicy.generalInformation.policyTerm')" type="number" :width="8" v-model="lifeGeneralInfo.policyTerm"></FITTextInput>
            </b-col>
            <b-col cols="6">
              <FITAutoSearch :label="$t('osm.contents.lifePolicy.generalInformation.originalAgent')" :width="8" v-model="originalAgent" dest="option" v-bind="agentAutoSearchParams"></FITAutoSearch>
              <FITAutoSearch :label="$t('osm.contents.lifePolicy.generalInformation.currentAgent')" :width="8" v-model="currentAgent" dest="option" v-bind="agentAutoSearchParams"></FITAutoSearch>
              <FITAutoSearch :label="$t('osm.contents.lifePolicy.generalInformation.originalReferrer')" :width="8" v-model="originalReferrer" dest="option" v-bind="agentAutoSearchParams"></FITAutoSearch>
              <FITAutoSearch :label="$t('osm.contents.lifePolicy.generalInformation.policyOwner')" :width="8" v-model="policyOwner" dest="option" v-bind="customerAutoSearchParams"></FITAutoSearch>
              <FITAutoSearch :label="$t('osm.contents.lifePolicy.generalInformation.insurer')" :width="8" v-model="insurer" dest="option" v-bind="customerAutoSearchParams"></FITAutoSearch>
              <FITTextInput :label="$t('osm.contents.lifePolicy.generalInformation.thirdParty')" :width="8" type="text" v-model="lifeGeneralInfo.levyOrMib"></FITTextInput>
              <FITTextInput :label="$t('osm.contents.lifePolicy.generalInformation.beneficiary')" :width="8" type="text" v-model="lifeGeneralInfo.beneficiary"></FITTextInput>
            </b-col>
          </b-row>
          <template>
            <b-row>
              <hr style="color:black; height:1px;" />
              <b-col cols="6">
                <FITDatePicker :label="$t('osm.contents.lifePolicy.generalInformation.commencementDate')" :width="8" v-model="lifeGeneralInfo.commencementDate" :placeholder="$t('general.selectDate')"></FITDatePicker>
              </b-col>
              <b-col cols="6">
                <FITDatePicker :label="$t('osm.contents.lifePolicy.generalInformation.issueDate')" :width="8" v-model="lifeGeneralInfo.issueDate" :placeholder="$t('general.selectDate')"></FITDatePicker>
              </b-col>
            </b-row>
          </template>
          <b-row>
            <b-col>
              <FITTextarea :label="$t('osm.contents.lifePolicy.generalInformation.remarks')" :rows="3" :width="10" v-model="lifeGeneralInfo.remarks"></FITTextarea>
              <FITWorkflowFileUpload ref="fitFileUpload" :uploadedFiles="uploadedFiles"></FITWorkflowFileUpload>
            </b-col>
          </b-row>
          <template>
            <hr style="color:black; height:1px;" />
            <h3><b><i class="fa fa-university mr-2"></i>{{$t('osm.contents.lifePolicy.payment')}}</b></h3>
            <b-row>
              <b-col cols="6">
                <FITTextInput :label="$t('osm.contents.lifePolicy.generalInformation.policyCurrency')" :width="8" type="text" v-model="lifeGeneralInfo.policyCurrency"></FITTextInput>
                <FITSelect :label="$t('osm.contents.lifePolicy.generalInformation.paymentMethod')" :width="8" :options="getTranslatedOptions(`${$i18n.locale}`,paymentMethodList)" v-model="lifeGeneralInfo.paymentMethod"></FITSelect>
                <FITSelect :label="$t('osm.contents.lifePolicy.generalInformation.companyBank')" :width="8" :options="getTranslatedOptions(`${$i18n.locale}`,companyBankList)" v-model="lifeGeneralInfo.companyBank"></FITSelect>
              </b-col>
              <b-col cols="6">
                <FITSelect :label="$t('osm.contents.lifePolicy.generalInformation.premiumType')" :width="8" :options="getTranslatedOptions(`${$i18n.locale}`,paymentModeList)" v-model="lifeGeneralInfo.premiumType"></FITSelect>
                <FITTextInput type="text" :label="$t('osm.contents.lifePolicy.generalInformation.paymentReference')" :width="8" v-model="lifeGeneralInfo.paymentReference"></FITTextInput>
              </b-col>
            </b-row>
          </template>
          <template>
            <hr style="color:black; height:1px;" />
            <h3><b><i class="fa fa-user-secret mr-2"></i>{{$t('osm.contents.lifePolicy.internalUse')}}</b></h3>
            <template>
              <b-row>
                <b-col cols="6">
                  <FITSelect :label="$t('osm.contents.lifePolicy.generalInformation.sentOutMedium')" :width="8" v-model="lifeGeneralInfo.sentOutMedium" :options="getTranslatedOptions(`${$i18n.locale}`,sentOutMediumOptions)"></FITSelect>
                  <FITDatePicker :label="$t('osm.contents.lifePolicy.generalInformation.sentOutDate')" :width="8" v-model="lifeGeneralInfo.sentOutDate" :placeholder="$t('general.selectDate')"></FITDatePicker>
                </b-col>
                <b-col cols="6">
                  <FITTextInput :label="$t('osm.contents.lifePolicy.generalInformation.sentOutReference')" v-model="lifeGeneralInfo.sentOutReference" :width="8" type="text"></FITTextInput>
                </b-col>
              </b-row>
            </template>
            <template>
              <b-row>
                <b-col cols="6">
                  <FITDatePicker :label="$t('osm.contents.lifePolicy.generalInformation.companyReceiveDate')" :width="8" v-model="lifeGeneralInfo.companyReceiveDate" :placeholder="$t('general.selectDate')"></FITDatePicker>
                  <FITDatePicker :label="$t('osm.contents.lifePolicy.generalInformation.customerReceiveDate')" :width="8" v-model="lifeGeneralInfo.customerReceiveDate" :placeholder="$t('general.selectDate')"></FITDatePicker>
                </b-col>
                <b-col>
                  <FITDatePicker :label="$t('osm.contents.lifePolicy.generalInformation.agentReceiveDate')" :width="8" v-model="lifeGeneralInfo.agentReceiveDate" :placeholder="$t('general.selectDate')"></FITDatePicker>
                </b-col>
              </b-row>
            </template>
          </template>
        </div>
      </FITFormCard>
      <div class="text-right">
        <FITButton @click="submitTransferIn" variant="primary" :text="$t('osm.contents.general.changeBusiness.transferIn')" size="md"></FITButton>
      </div>
    </div>
  </b-row>
</template>
<script type="text/javascript">
import { FITFormCard, FITvSelect, FITTextInput, FITDatePicker, FITSelect, FITTextarea, FITAutoSearch, FITWorkflowFileUpload, FITButton } from '@/components'
import { mapState, mapGetters } from 'vuex'
import Vue from 'vue'
export default {

  name: 'TransferIn',
  created() {
    this.getSelectionsList();
  },
  methods: {
    uploadFile() {
      var fileData = this.$refs.fitFileUpload.formUploadFiles();
      console.debug(fileData);
      Vue.set(this, 'newFileUploaded', fileData);
      return fileData;
    },
    onClickCbModalOk(evt) {
      evt.preventDefault();
      var fileData = this.uploadFile();
      Vue.set(this.lifeGeneralInfo, 'files', fileData.files);
      Vue.set(this.lifeGeneralInfo, 'attachment', fileData.attachment);
      this.$store.dispatch('LifePolicy/transferInLife', this.lifeGeneralInfo).then(() => {
        this.showAlert();
        this.$refs.cbModal.hide();
        this.$router.replace({ name: "Life Policy List", params: { showRouteUpdateAlert: true } });

      }).catch((err) => {
        Vue.set(this, 'isFirstTimeClickedModalOk', true);
        this.$refs.cbModal.hide();
        this.showAlert();
      })
    },
    submitTransferIn() {
      this.$refs.cbModal.show();
    },
    getOptions(columnName) {
      var obj = this.allSelections.filter((item) => { return item.name === columnName });
      if (obj[0] == null) {
        return []
      }
      if (obj[0].options.length == 0) {
        return null;
      }
      return obj[0].options;
    },
    showAlert() {
      this.alertCd = this.dismissSecs;
    },
    getSelectionsList() {
      this.$store.dispatch('getAllSelections', "life")
        .then((response) => {
          if (response.status != 200) {
            return;
          }
          this.$store.commit({ type: 'LifePolicy/setLifeSelectionList', lifeSelectionList: response.data })
          Vue.set(this, 'allSelections', response.data);
        }, (err) => {
          console.error(err);
        })
    },
  },
  computed: {
    ...mapGetters("LifePolicy", [
      // 'getTranslatedPolicyTypeList',
      'getTranslatedOptions'
    ]),
    sentOutMediumOptions() {
      return this.getOptions("sentOutMedium");
    },
    companyBankList() {
      return this.getOptions("companyBank")
    },
    paymentMethodList() {
      return this.getOptions("paymentMethod")
    },
    paymentModeList() {
      return this.getOptions("premiumType");
    },
  },
  data() {
    return {
      alertCd: 0,

      dismissSecs: 3,
      lifeGeneralInfo: {},
      selectedProduct: { ID: -1 },
      originalReferrer: { ID: -1 },
      originalAgent: { ID: -1 },
      currentAgent: { ID: -1 },
      insurer: { ID: -1 },
      policyOwner: { ID: -1 },
      productAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'gi',
        paras: [{ key: 'type', value: "life" }],
        showItems: ['productEnglishName', 'productChineseName']
      },
      agentAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'option',
        paras: [{ key: 'type', value: 'agent' }],
        showItems: ['englishFullname', 'chineseFullname', 'agentCode'],
      },
      customerAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'option',
        paras: [{ key: 'type', value: 'customer' }],
        showItems: ['englishFullname', 'chineseFullname'],
      },
      uploadedFiles: [],
      allSelections: []
    }
  },
  components: {
    FITButton,
    FITFormCard,
    FITvSelect,
    FITTextInput,
    FITDatePicker,
    FITSelect,
    FITTextarea,
    FITAutoSearch,
    FITWorkflowFileUpload
  },
}

</script>



// WEBPACK FOOTER //
// src/Osm/LifePolicy/containers/TransferInContainer.vue